import React from 'react';
import styles from './index.module.scss';

const MiniTag = props => {
  const {
    loading,
    isRemovable,
    isItemTag,
    image,
    label,
    onRemove,
  } = props;
  
  return (
    <div className={`${styles['mini-tag']} ${loading && styles['tag-disable']} ${isItemTag && styles['item-tag']}`}>
      {isItemTag && (
        <img src={image?._url || ''} />
      )}
      <div className={styles['tag-label']}>{label.substr(0, 30)}{label.length > 31 ? '...' : ''}</div>
      {isRemovable && (
        <div className={styles['remove-icon']} onClick={onRemove}>
          <i className={'fa fa-times'} />
        </div>
      )}
    </div>
  );
};

export default MiniTag;